<template>
  <div class="signUpContent">
    <div class="logoImgWrapper">
      <img class="logoImg" v-bind:src="logoImg">
    </div>
    <div class="signUpContentHeader">
      <img class="loginBackPageArrowImg" v-bind:src="backPageArrowImg" v-on:click="$router.push('/')">
      <span>회원가입</span>
    </div>
    <div class="signUpContentWrapper">
      <login-input-text-and-button v-bind="emailInput" v-on:returnText="getEmail" v-on:sendVerifyEmail="sendVerifyEmail"></login-input-text-and-button>
      <span class="successMsg" v-if="successMsg != null">{{successMsg}}</span>
      <login-input-text v-bind="verifyNumberInput" v-on:returnText="getVerifyNumber"></login-input-text>
      <login-input-text v-bind="passwordInput" v-on:returnText="getPassword"></login-input-text>
      <login-input-file v-bind="fileInput" v-on:returnFileInfo="getFileInfo" v-on:openSignUpRegCertModal="openSignUpRegCertModal"></login-input-file>
      <div class="signUpTosWrapper">
        <span>이용약관</span>
        <div class="confirmAllCheckBox">
          <img v-bind:src="tosConfirmAllIcon" v-on:click="onCheckConfirmAll">
          <span>전체동의</span>
        </div>
        <div class="confirmOptionWrapper" v-for="tosOption in tosOptions" v-bind:key="tosOption.index">
          <div class="confirmDiv">
            <img v-bind:src="tosOption.checkIcon" v-on:click="onCheckTosOption(tosOption.index)">
            <span>{{tosOption.optionName}}</span>
          </div>
          <div class="details">
            <span v-on:click="openSignUpTos(tosOption.index, tosOption.optionName)">상세보기</span>
          </div>
        </div>
      </div>
    </div>
    <div class="signUpFooter">
      <div class="signUpButtonWrapper">
        <button class="signUpBtn" v-bind:disabled="setDisable" v-on:click="onSignUp">회원가입</button>
      </div>
      <div class="singUpValidTextWrapper">
        <span v-if="validText.invalidFormatEmail">* 이메일 형식을 확인해주세요.<br></span>
        <span v-if="validText.invalidFormatPassword">* 비밀번호 형식을 확인해주세요. (숫자, 영문자, 특수문자 포함 8~16자)<br></span>
        <span v-if="validText.duplicatedEmail">* 폴라이드 앱에서 이미 사용중인 메일입니다.<br></span>
        <span v-if="validText.duplicatedEmailAdUser">* 이미 사용중인 메일입니다.<br></span>
        <span v-if="validText.unknownSendEmailError">* 메일 전송에 실패했습니다.<br></span>
        <span v-if="validText.notSendVerifyEmail">* 인증하기 버튼을 클릭해 이메일 인증을 진행해주세요.<br></span>
        <span v-if="validText.invalidVerifyNumber">* 인증번호가 올바르지 않습니다.<br></span>
        <span v-if="validText.expiredVerifyNumber">* 인증번호가 만료되었습니다. 새 인증번호를 발급해주세요.<br></span>
      </div>
    </div>
  </div>
</template>

<script>
import loginInputText from '../elements/loginInputText.vue'
import loginInputTextAndButton from '../elements/loginInputTextAndButton'
import loginInputFile from '../elements/loginInputFile.vue'

export default {
  components: {
    'login-input-text': loginInputText,
    'login-input-text-and-button': loginInputTextAndButton,
    'login-input-file': loginInputFile
  },
  data () {
    return {
      logoImg: require('@/assets/img/logo.png'),
      emailInput: {
        spanText: '이메일주소',
        placeHolder: '이메일을 입력하세요',
        isPassword: false,
        buttonValue: '인증하기'
      },
      verifyNumberInput: {
        spanText: '인증번호',
        placeHolder: '인증번호를 입력하세요',
        isPassword: false
      },
      passwordInput: {
        spanText: '비밀번호',
        placeHolder: '비밀번호를 입력하세요',
        isPassword: true
      },
      fileInput: {
        spanText: '사업자등록증 등록(선택)'
      },
      email: null,
      password: null,
      verifyNumber: null,
      certificateImg: null,
      backPageArrowImg: require('@/assets/img/back_page_arrow.png'),
      verifiedEmail: null,
      successMsg: null,
      tosConfirmAllIcon: null,
      isTosConfirmAllChecked: null,
      tosOptions: [],
      validText: {
        invalidFormatEmail: false,
        invalidFormatPassword: false,
        invalidVerifyNumber: false,
        expiredVerifyNumber: false,
        duplicatedEmail: false,
        duplicatedEmailAdUser: false,
        notSendVerifyEmail: false,
        unknownSendEmailError: false
      }
    }
  },
  methods: {
    getEmail: function (returnText) {
      this.email = returnText
    },
    getPassword: function (returnText) {
      this.password = returnText
    },
    getVerifyNumber: function (returnText) {
      this.verifyNumber = returnText
    },
    getFileInfo: function (returnFileInfo) {
      this.certificateImg = returnFileInfo
    },
    openSignUpRegCertModal: function () {
      this.$emit('openSignUpRegCertModal')
    },
    sendVerifyEmail: async function (email) {
      this.successMsg = null
      this.setAllValidTextState(false)
      if(this.emailValidCheck(email)) {
        try {
          let verifyEmailResponse = await this.$store.dispatch('sendVerifyEmailApi', {email: email})
          if (verifyEmailResponse.data.result.code === 1000) {
            // 앱에서 이미 존재하는 유저
            this.validText.duplicatedEmail = true
          } else if (verifyEmailResponse.data.result.code === 1016) {
            // 웹에서 이미 존재하는 유저
            this.validText.duplicatedEmailAdUser = true
          } else if (verifyEmailResponse.data.result.code === 200) {
            // 메일 전송 성공
            this.verifiedEmail = email
            this.successMsg = '해당 이메일로 인증번호를 전송했습니다. 확인해주세요.'
          }else {
            this.validText.unknownSendEmailError = true
          }
        } catch (error) {
          console.log(error.response)
        }
      }
    },
    onCheckConfirmAll: function () {
      this.tosOptions.forEach(items => {
        items.isChecked = !this.isTosConfirmAllChecked
        items.checkIcon = this.isTosConfirmAllChecked ? require('@/assets/img/checkbox_not_selected_img.png') : require('@/assets/img/checkbox_selected_img.png')
      })
      this.tosConfirmAllIcon = this.isTosConfirmAllChecked ? require('@/assets/img/checkbox_not_selected_img.png') : require('@/assets/img/checkbox_selected_img.png')
      this.isTosConfirmAllChecked = !this.isTosConfirmAllChecked
    },
    onCheckTosOption: function (checkBoxIndex) {
      let selectedArr = this.tosOptions.find(items => items.index === checkBoxIndex)
      selectedArr.checkIcon = selectedArr.isChecked ? require('@/assets/img/checkbox_not_selected_img.png') : require('@/assets/img/checkbox_selected_img.png')
      selectedArr.isChecked = !selectedArr.isChecked

      this.tosConfirmAllIcon = this.tosOptions.find(items => !items.isChecked) == null ? require('@/assets/img/checkbox_selected_img.png') : require('@/assets/img/checkbox_not_selected_img.png')
      this.isTosConfirmAllChecked = this.tosOptions.find(items => !items.isChecked) == null
    },
    openSignUpTos: function (index, optionName) {
      this.$emit('openSignUpTos', {index: index, optionName: optionName})
    },
    onSignUp: async function () {
      this.setAllValidTextState(false)
      if(this.emailValidCheck(this.email) && this.passwordValidCheck(this.password) &&
        this.sendVerifyValidCheck(this.email, this.verifiedEmail) && await this.verifyNumberValidCheck(this.email, this.verifyNumber)) {
        try {
          let signUpTokenResponse = await this.$store.dispatch('signUpTokenApi')
          // eslint-disable-next-line no-unused-vars
          const response = await this.$store.dispatch('signUpApi',
            {
              signUpToken: signUpTokenResponse.data.access_token,
              email: this.email,
              password: this.password,
              certificate: this.certificateImg,
              joinType: 'EMAIL',
              agreeLocation: this.tosOptions[2].isChecked,
              agreePromotion: this.tosOptions[3].isChecked
            }
          )
          this.$store.commit('setLastSignUpUserEmail', {lastSignUpUserEmail: this.email})
          alert('회원가입이 완료되었습니다.')
          await this.$router.push({name: 'signIn'})
          // }
        }catch (error) {
          console.log(error.response)
        }
      }
    },
    emailValidCheck: function (email) {
      if(/^[_0-9a-zA-Z-]+@[0-9a-zA-Z-]+(.[_0-9a-zA-Z-]+)*$/.test(email)) {
        return true
      }else{
        this.validText.invalidFormatEmail = true
        return false
      }
    },
    passwordValidCheck: function (password) {
      if(/^(?=.*[0-9])(?=.*[A-Za-z])(?=.*\W)(?=\S+$).{8,16}$/.test(password)) {
        return true
      }else{
        this.validText.invalidFormatPassword = true
        return false
      }
    },
    sendVerifyValidCheck: function (email, verifiedEmail) {
      if (email === verifiedEmail) {
        return true
      }else {
        this.validText.notSendVerifyEmail = true
        return false
      }
    },
    verifyNumberValidCheck: async function (email, verifyNumber) {
      let verifyNumberResponse = await this.$store.dispatch('verifyNumberApi', {email: email, verifyNumber: verifyNumber})
      if (verifyNumberResponse.data.result.code === 4003) {
        this.validText.expiredVerifyNumber = true
        return false
      }else if (verifyNumberResponse.data.result.code === 200) {
        return true
      }else {
        this.validText.invalidVerifyNumber = true
        return false
      }
    },
    setAllValidTextState: function (state) {
      this.validText.invalidFormatEmail = state
      this.validText.invalidFormatPassword = state
      this.validText.invalidVerifyNumber = state
      this.validText.expiredVerifyNumber = state
      this.validText.duplicatedEmail = state
      this.validText.duplicatedEmailAdUser = state
      this.validText.notSendVerifyEmail = state
      this.validText.unknownSendEmailError = state
    },
    browserCheck: function () {
      if(this.$browserDetect.isIE) {
        alert('폴라이드는 인터넷 익스플로러(IE) 브라우저를 지원하지 않습니다. 타 브라우저를 이용해주세요.')
        this.$router.push({name: 'signIn'})
      }
    }
  },
  computed: {
    setDisable: function () {
      return (this.email === null || this.email === '' ||
        this.password === null || this.password === '' ||
        this.verifyNumber === null || this.verifyNumber === '' ||
        !this.tosOptions[0].isChecked || !this.tosOptions[1].isChecked)
    }
  },
  created: function () {
    this.browserCheck()
    this.tosConfirmAllIcon = require('@/assets/img/checkbox_not_selected_img.png')
    this.isTosConfirmAllChecked = false
    this.tosOptions = [
      {
        index: 0,
        optionName: '폴라이드 서비스,소비자조사 및 광고 이용약관 (필수)',
        checkIcon: require('@/assets/img/checkbox_not_selected_img.png'),
        isChecked: false
      },
      {
        index: 1,
        optionName: '개인정보 수집 및 이용에 대한 안내 (필수)',
        checkIcon: require('@/assets/img/checkbox_not_selected_img.png'),
        isChecked: false
      },
      {
        index: 2,
        optionName: '위치정보 이용약관 동의 (선택)',
        checkIcon: require('@/assets/img/checkbox_not_selected_img.png'),
        isChecked: false
      },
      {
        index: 3,
        optionName: '프로모션 정보 수신 동의 (선택)',
        checkIcon: require('@/assets/img/checkbox_not_selected_img.png'),
        isChecked: false
      }
    ]
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/login.css';
.signUpContent{
  position: relative;
}

.logoImgWrapper {
  position: absolute;
  left: 0;
  top: -68px;
}

.logoImgWrapper > .logoImg {
  width: 92px;
  height: 23px;
}

.signUpContentHeader{
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  height: 32px;
  font-size: 24px;
}

.signUpContentWrapper{
  padding: 15px 0;
  width: 450px;
  height: 365px;
  overflow-y: auto;
}

.signUpContentWrapper::-webkit-scrollbar {
  width: 4px;
}
.signUpContentWrapper::-webkit-scrollbar-thumb {
  background-color: #000000;
}
.signUpContentWrapper::-webkit-scrollbar-track {
  background-color: #EFEFEF;
}

.signUpTosWrapper{
  margin-top: 25px;
}

.signUpTosWrapper > span{
  font-size: 11px;
  color: rgb(0,153,255);
}

.confirmAllCheckBox, .confirmDiv {
  display: flex;
  display: -ms-flexbox;
  align-items: center;
}

.confirmAllCheckBox {
  margin-top: 16px;
}

.confirmAllCheckBox > img, .confirmDiv > img{
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.confirmDiv > img{
  margin-left: 40px;
}

.confirmAllCheckBox > span, .confirmDiv > span{
  margin-left: 8px;
  font-size: 13px;
}

.confirmOptionWrapper{
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  margin-top: 16px;
}

.details > span{
  cursor: pointer;
  font-size: 11px;
  text-decoration: underline;
  margin-left: 80px;
}

.singUpValidTextWrapper{
  width: 400px;
  text-align: right;
}

.singUpValidTextWrapper > span{
  color: red;
  font-size: 13px;
}

.successMsg {
  font-size: 13px;
  color: rgb(0,153,255);
}

.signUpFooter{
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  margin-top: 28px;
}

.signUpFooter > .signUpButtonWrapper {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/views/singUp.vue